//  ----------      START   IMPORT  BLOCK       ----------
import { useParams } from 'react-router-dom';
import DocsContainer from '../DocsLayout/DocsContainer';
import { getPatientsContent } from './PatientsContent';
import BaseLayout from '../BaseLayout/BaseLayout';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Config
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
//  ----------      END   IMPORT  BLOCK       ----------


function PatientsBasePage({  }) {
  //  Consume context
  const { lan } = useLanguage()
  const { sectionId } = useParams();
  
  const content = getPatientsContent(lan)

  return (
    <BaseLayout lan={lan}>
      <DocsContainer sections={content} basePath={FRONTEND_ROUTES.static_patients}/>
    </BaseLayout>
  );
}

export default PatientsBasePage;

